import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faFile, faGear } from '@fortawesome/free-solid-svg-icons';
import 'react-reflex/styles.css';
import { ReflexContainer, ReflexElement } from 'react-reflex';
import { ChatActions } from './chatActions';
import { ChatDisplay } from './chatDisplay';
import { Button } from '@quyva/shared-ui';
import AudioPlayer from '../AudioPlayer/audioPlayer';
import { selectionModeCode, toSentenceCase } from '@quyva/common';
import { Settings } from '../settings';
import { ResponseEnum } from '../enums/universalEnums';

const audioSource = '/waitingMusic.mp3';

export const ChatContainer = ({
    activeQuestion,
    questionsData,
    isGenerating,
    query,
    currentQnA,
    user,
    setQuery,
    handleSubmit,
    uploadedFiles,
    setUploadedFiles,
    qnaLoadingText,
    togglePdfVisibility,
    selectedProductCategory,
    selectedProduct,
    isSmallScreen,
    enableAudioFeature,
    hasProductCategories,
    hasProducts,
    enableReader,
    setEnableReader,
    enableMusic,
    setEnableMusic,
    selectionMode,
    enableSpeaker,
    setEnableSpeaker,
    activeAudioId,
    setActiveAudioId,
    audioUrlData,
    vendorDetails,
}) => {
    const [activeAnswer, setActiveAnswer] = useState('');
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [pendingQuickSubmit, setPendingQuickSubmit] = useState(false);

    useEffect(() => {
        if (
            activeQuestion &&
            activeQuestion.answer &&
            activeAnswer !== activeQuestion.answer
        ) {
            setActiveAnswer(activeQuestion.answer);
        }
    }, [activeQuestion]);

    const handleQuickSubmit = (actualQuery) => {
        const selectionModeQuery = `${selectionModeCode} ${actualQuery}`;
        setQuery(selectionModeQuery);
        setPendingQuickSubmit(true); // tell useEffect to run handleSubmit after query is set
    };
    useEffect(() => {
        if (pendingQuickSubmit && query) {
            handleSubmit();
            setPendingQuickSubmit(false);
            setQuery('');
        }
    }, [pendingQuickSubmit, query]);

    return (
        <>
            {showSettingsModal && (
                <Settings
                    setShowSettingsModal={setShowSettingsModal}
                    enableReader={enableReader}
                    setEnableReader={setEnableReader}
                    enableMusic={enableMusic}
                    setEnableMusic={setEnableMusic}
                    vendorDetails={vendorDetails}
                    enableAudioFeature={enableAudioFeature}
                />
            )}

            <ReflexContainer orientation='horizontal'>
                <ReflexElement
                    className='header border-b shadow-sm'
                    style={{
                        minHeight: '3.5rem',
                        height: '3.5rem',
                        maxHeight: '3.5rem',
                    }}
                >
                    <div className='flex pane-content w-full h-full p-2 items-center'>
                        <div className='w-full h-full flex items-center justify-between item-center text-texts-secondary truncate px-2'>
                            <div className='w-fit'>
                                <FontAwesomeIcon
                                    icon={faComments}
                                    className='mr-2 drop-shadow text-backgrounds-primary200'
                                />
                                <span className='overflow-ellipsis overflow-hidden font-semibold w-full mr-2 text-texts-secondary300'>
                                    Chats
                                </span>
                            </div>

                            <div className='flex items-center justify-between'>
                                <div className=' ml-2 flex items-center rounded-full border'>
                                    <Button
                                        text={null}
                                        className={''}
                                        hoverText={'Settings'}
                                        disabled={false}
                                        onClick={() => {
                                            setShowSettingsModal(true);
                                        }}
                                        icon={faGear}
                                        type={'success'}
                                    />
                                </div>

                                {isSmallScreen && (
                                    <Button
                                        className={'ml-2'}
                                        text={null}
                                        hoverText={'View Source'}
                                        icon={faFile}
                                        onClick={(e) => {
                                            togglePdfVisibility();
                                        }}
                                        type={'success'}
                                        disabled={!activeQuestion}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </ReflexElement>

                <ReflexElement flex={1}>
                    <div className='pane-content h-full'>
                        <ChatDisplay
                            activeQuestion={activeQuestion}
                            questionsData={questionsData}
                            setQuery={setQuery}
                            currentQnA={currentQnA}
                            user={user}
                            isGenerating={isGenerating}
                            qnaLoadingText={qnaLoadingText}
                            selectedProductCategory={selectedProductCategory}
                            selectedProduct={selectedProduct}
                            isSmallScreen={isSmallScreen}
                            hasProductCategories={hasProductCategories}
                            hasProducts={hasProducts}
                            activeAudioId={activeAudioId}
                            setActiveAudioId={setActiveAudioId}
                            audioUrlData={audioUrlData}
                            enableAudioFeature={enableAudioFeature}
                            enableReader={enableReader}
                            enableSpeaker={enableSpeaker}
                            setEnableSpeaker={setEnableSpeaker}
                            vendorDetails={vendorDetails}
                        />
                        <AudioPlayer
                            play={isGenerating && enableMusic}
                            source={audioSource}
                        />
                    </div>
                </ReflexElement>

                <ReflexElement
                    className='footer border-t shadow'
                    style={{
                        minHeight:
                            Array.isArray(uploadedFiles) && uploadedFiles.length > 0
                                ? '7.5rem'
                                : '4rem',
                        height:
                            Array.isArray(uploadedFiles) && uploadedFiles.length > 0
                                ? '7.5rem'
                                : '4rem',
                        maxHeight:
                            Array.isArray(uploadedFiles) && uploadedFiles.length > 0
                                ? '7.5rem'
                                : '4rem',
                    }}
                >
                    <div className='pane-content w-full h-full'>
                        <div className='flex items-center justify-end w-full h-full px-2'>
                            <ChatActions
                                query={query}
                                currentQnA={currentQnA}
                                setQuery={setQuery}
                                handleSubmit={handleSubmit}
                                uploadedFiles={uploadedFiles}
                                setUploadedFiles={setUploadedFiles}
                                isGenerating={isGenerating}
                                selectedProductCategory={
                                    selectedProductCategory
                                }
                                selectedProduct={selectedProduct}
                                isSmallScreen={isSmallScreen}
                                enableSpeaker={enableSpeaker}
                                setEnableSpeaker={setEnableSpeaker}
                                activeAnswer={activeAnswer}
                                enableAudioFeature={enableAudioFeature}
                                setActiveAudioId={setActiveAudioId}
                            />
                        </div>
                    </div>
                </ReflexElement>
            </ReflexContainer>
        </>
    );
};
